export class PatientCareTrafficLight {
  public Color: string;
  public HtmlColor: string;
  public Deleted: boolean;
  public Id: number;
  public Caption: string;
  public Name: string;
  public ServiceId: number;
}
